import dataReport from '@utils/data-report';
import { useCallback } from 'react';

const useReport = () => {
  // 页面曝光
  const exposureReport = useCallback(() => {
    dataReport('e#event_become_sponsor#all#exposure');
  }, []);

  // 修改头像
  const modifyReport = useCallback(() => {
    dataReport('e#event_become_sponsor#modify_avatar#click');
  }, []);

  // 名称点击
  const nameReport = useCallback(() => {
    dataReport('e#event_become_sponsor#name#click');
  }, []);

  // 行业点击
  const industryReport = useCallback(() => {
    dataReport('e#event_become_sponsor#industry#click');
  }, []);

  // 点击创建
  const creatReport = useCallback((name: string, industry: string) => {
    dataReport('e#event_become_sponsor#creat#click', {
      name,
      industry,
    });
  }, []);

  return {
    exposureReport,
    modifyReport,
    nameReport,
    industryReport,
    creatReport,
  };
};

export default useReport;
